<div class="container-fluid complyon-page conflicts-page px-3 px-md-4 px-xl-4 py-3">
  <div class="complyon-shell conflicts-shell mx-auto">
    <section class="mb-3">
      <h1 class="complyon-title conflicts-title mb-2 text-l">Conflicts of interest</h1>
      <p class="complyon-subtitle conflicts-subtitle mb-0 text-s">Declarations, related-party matching, supplier links, gifts, recusals and ethics.</p>
    </section>

    <section class="d-flex flex-wrap justify-content-between align-items-center gap-3 mb-3">
      <div class="d-flex flex-wrap align-items-center gap-1">
        <button
          v-for="tab in tabs"
          :key="tab.id"
          type="button"
          class="btn doa-tab-btn fw-semibold"
          :class="{ active: active_tab === tab.id }"
          @click="set_tab(tab.id)"
        >
          <span>{{ tab.label }}</span>
          <span v-if="tab.count !== undefined" class="doa-tab-count">{{ tab.count }}</span>
        </button>
      </div>

      <button type="button" class="btn doa-reset-btn d-inline-flex align-items-center gap-1">
        <i class="bi bi-arrow-clockwise"></i>
        <span>Reset sample</span>
      </button>
    </section>

    <div v-if="active_tab === 'register'">
      <section class="row g-3 mb-3">
        <div v-for="card in register_cards" :key="card.label" class="col-12 col-md-6 col-xl-3">
          <article class="complyon-card rounded-4 p-3 h-100">
            <div class="complyon-stat-label text-xs">{{ card.label }}</div>
            <div class="complyon-stat-value text-l" :class="card.accent === 'red' ? 'text-danger' : card.accent === 'amber' ? 'text-warning-emphasis' : card.accent === 'green' ? 'text-success' : 'text-dark'">{{ card.value }}</div>
            <div class="complyon-stat-note mt-3 text-xs">{{ card.note }}</div>
          </article>
        </div>
      </section>

      <section class="complyon-panel conflicts-panel rounded-4 overflow-hidden">
        <div class="d-flex align-items-start justify-content-between gap-2 px-3 pt-3">
          <div>
            <div class="complyon-section-title text-s">Declaration register</div>
            <div class="complyon-section-subtitle text-xs">Every declaration - person, type, nature, related party, rating and status. Open one for the full conflict file.</div>
          </div>
          <button type="button" class="btn config-navbar-primary-action finance-action-btn" @click="open_new_declaration_modal">
            <i class="bi bi-plus-lg"></i>
            <span>New declaration</span>
          </button>
        </div>

        <div class="table-responsive">
          <table class="table complyon-table conflicts-table align-middle mb-0">
            <thead>
              <tr>
                <th class="ps-3 text-xs">Ref</th>
                <th class="text-xs">Person</th>
                <th class="text-xs">Department</th>
                <th class="text-xs">Type</th>
                <th class="text-xs">Related party</th>
                <th class="text-xs">Rating</th>
                <th class="text-xs">Status</th>
                <th class="pe-3"></th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="row in register_rows"
                :key="row.ref"
                class="conflicts-register-row"
                :class="{ 'is-active': active_declaration_drawer_ref === row.ref }"
                tabindex="0"
                @click="open_declaration_drawer(row)"
                @keydown.enter.prevent="open_declaration_drawer(row)"
                @keydown.space.prevent="open_declaration_drawer(row)"
              >
                <td class="ps-3 fw-semibold text-success">{{ row.ref }}</td>
                <td>
                  <div class="conflicts-name">{{ row.person }}</div>
                  <div class="text-xs text-secondary">{{ row.role }}</div>
                </td>
                <td>{{ row.department }}</td>
                <td><span class="badge rounded-pill bg-light text-secondary border border-light">{{ row.type }}</span></td>
                <td>{{ row.related_party }}</td>
                <td><span class="badge rounded-pill" :class="row.rating === 'Critical' ? 'bg-danger-subtle text-danger-emphasis' : row.rating === 'High' ? 'bg-danger-subtle text-danger-emphasis' : row.rating === 'None' ? 'bg-light text-secondary border border-light' : row.rating === 'Low' ? 'bg-success-subtle text-success-emphasis' : 'bg-warning-subtle text-warning-emphasis'">{{ row.rating }}</span></td>
                <td><span class="badge conflicts-badge" :class="row.status.class">{{ row.status.label }}</span></td>
                <td class="pe-3 text-end"><i class="bi bi-chevron-right finance-arrow"></i></td>
              </tr>
            </tbody>
          </table>
        </div>
      </section>
    </div>

    <div v-else-if="active_tab === 'declaration-types'">
      <p class="complyon-section-subtitle text-xs mb-3">The five declaration programmes. Each card shows submission progress and the people still outstanding.</p>
      <section class="row g-3">
        <div v-for="card in declaration_cards" :key="card.title" class="col-12 col-md-6 col-xl-4">
          <article class="complyon-card rounded-4 p-3 h-100">
            <div class="d-flex align-items-start justify-content-between gap-3">
              <div class="d-flex align-items-center gap-2">
                <span class="rounded-3 d-inline-flex align-items-center justify-content-center flex-shrink-0" style="width:32px;height:32px;background:#e5f7f3;">
                  <i class="bi" :class="card.icon"></i>
                </span>
                <div class="fw-semibold">{{ card.title }}</div>
              </div>
              <span class="badge rounded-pill" :class="card.progress === 100 ? 'bg-success-subtle text-success-emphasis' : 'bg-danger-subtle text-danger-emphasis'">{{ card.progress }}%</span>
            </div>

            <div class="mt-2">
              <span class="complyon-stat-value text-l">{{ card.summary.split(' / ')[0] }}</span>
              <span class="text-xs text-secondary"> / {{ card.summary.split(' / ')[1] }}</span>
            </div>

            <div class="progress mt-3" style="height: 4px;">
              <div class="progress-bar" :class="card.progress === 100 ? 'bg-success' : card.progress >= 25 ? 'bg-warning' : 'bg-danger'" :style="{ width: `${card.progress}%` }"></div>
            </div>

            <div class="mt-3 text-xs">{{ card.note }}</div>
            <div class="mt-3 d-flex flex-column gap-2">
              <component
                :is="item.drawer_ref ? 'button' : 'div'"
                v-for="item in card.items"
                :key="`${card.title}-${item.ref}`"
                class="d-flex align-items-center justify-content-between gap-2"
                :class="item.drawer_ref ? 'btn btn-link w-100 p-0 text-decoration-none text-reset text-start conflicts-declaration-item-trigger' : ''"
                :type="item.drawer_ref ? 'button' : null"
                @click="item.drawer_ref ? open_declaration_type_item_drawer(item) : null"
              >
                <div class="d-flex align-items-center gap-2 min-w-0">
                  <span class="rounded-circle flex-shrink-0" :style="{ width: '8px', height: '8px', backgroundColor: item.accent === 'green' ? '#16815f' : item.accent === 'amber' ? '#c75a06' : '#c1261a' }"></span>
                  <div class="text-truncate">{{ item.ref }} - {{ item.note }}</div>
                </div>
                <i v-if="item.drawer_ref" class="bi bi-chevron-right finance-arrow"></i>
              </component>
            </div>
          </article>
        </div>
      </section>
    </div>

    <div v-else-if="active_tab === 'assessment-rating'">
      <section class="row g-3 mb-3">
        <div v-for="card in assessment_cards" :key="card.label" class="col-12 col-md-6 col-xl-3">
          <article class="complyon-card rounded-4 p-3 h-100">
            <div class="complyon-stat-label text-xs">{{ card.label }}</div>
            <div class="complyon-stat-value text-l" :class="card.accent === 'red' ? 'text-danger' : card.accent === 'amber' ? 'text-warning-emphasis' : 'text-success'">{{ card.value }}</div>
            <div class="complyon-stat-note mt-3 text-xs">{{ card.note }}</div>
          </article>
        </div>
      </section>

      <section class="complyon-panel rounded-4 overflow-hidden">
        <div class="px-3 pt-3">
          <div class="complyon-section-title text-s">Conflict assessment & rating</div>
          <div class="complyon-section-subtitle text-xs">Declarations sorted by conflict rating - assess, rate and decide. 2 awaiting assessment.</div>
        </div>

        <div class="table-responsive">
          <table class="table complyon-table align-middle mb-0">
            <thead>
              <tr>
                <th class="ps-3 text-xs">Ref</th>
                <th class="text-xs">Person</th>
                <th class="text-xs">Type</th>
                <th class="text-xs">Nature of interest</th>
                <th class="text-xs">Rating</th>
                <th class="text-xs">Decision</th>
                <th class="pe-3"></th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="row in assessment_rows"
                :key="row.ref"
                class="conflicts-register-row"
                :class="{
                  'bg-light': row.ref === 'COI-03',
                  'is-active': active_declaration_drawer_ref === row.ref
                }"
                tabindex="0"
                @click="open_declaration_drawer_by_ref(row.ref)"
                @keydown.enter.prevent="open_declaration_drawer_by_ref(row.ref)"
                @keydown.space.prevent="open_declaration_drawer_by_ref(row.ref)"
              >
                <td class="ps-3 fw-semibold text-success">{{ row.ref }}</td>
                <td class="fw-semibold">{{ row.person }}</td>
                <td>{{ row.type }}</td>
                <td>{{ row.nature }}</td>
                <td><span class="badge rounded-pill" :class="row.rating === 'Critical' ? 'bg-danger-subtle text-danger-emphasis' : row.rating === 'High' ? 'bg-danger-subtle text-danger-emphasis' : row.rating === 'None' ? 'bg-light text-secondary border border-light' : row.rating === 'Low' ? 'bg-success-subtle text-success-emphasis' : 'bg-warning-subtle text-warning-emphasis'">{{ row.rating }}</span></td>
                <td>{{ row.decision }}</td>
                <td class="pe-3 text-end"><i class="bi bi-chevron-right finance-arrow"></i></td>
              </tr>
            </tbody>
          </table>
        </div>
      </section>
    </div>

    <div v-else-if="active_tab === 'recusals-restrictions'">
      <section class="row g-3 mb-3">
        <div v-for="card in recusal_cards" :key="card.label" class="col-12 col-md-6 col-xl-3">
          <article class="complyon-card rounded-4 p-3 h-100">
            <div class="complyon-stat-label text-xs">{{ card.label }}</div>
            <div class="complyon-stat-value text-l" :class="card.accent === 'red' ? 'text-danger' : 'text-warning-emphasis'">{{ card.value }}</div>
            <div class="complyon-stat-note mt-3 text-xs">{{ card.note }}</div>
          </article>
        </div>
      </section>

      <section class="complyon-panel rounded-4 overflow-hidden mb-3">
        <div class="px-3 pt-3">
          <div class="complyon-section-title text-s">Recusal tracking</div>
          <div class="complyon-section-subtitle text-xs">Who has stepped away from which decision, and when. Click to open the declaration.</div>
        </div>

        <div class="table-responsive">
          <table class="table complyon-table align-middle mb-0">
            <thead>
              <tr>
                <th class="ps-3 text-xs">Ref</th>
                <th class="text-xs">Person</th>
                <th class="text-xs">Matter recused from</th>
                <th class="text-xs">Date</th>
                <th class="text-xs">Status</th>
                <th class="pe-3"></th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="row in recusal_rows"
                :key="row.id"
                class="conflicts-register-row"
                :class="{ 'is-active': active_declaration_drawer_row_key === row.id }"
                tabindex="0"
                @click="open_recusal_drawer(row)"
                @keydown.enter.prevent="open_recusal_drawer(row)"
                @keydown.space.prevent="open_recusal_drawer(row)"
              >
                <td class="ps-3 fw-semibold text-success">{{ row.ref }}</td>
                <td class="fw-semibold">{{ row.person }}</td>
                <td>{{ row.matter }}</td>
                <td class="fw-semibold">{{ row.date }}</td>
                <td><span class="badge rounded-pill bg-warning-subtle text-warning-emphasis">{{ row.status }}</span></td>
                <td class="pe-3 text-end"><i class="bi bi-chevron-right finance-arrow"></i></td>
              </tr>
            </tbody>
          </table>
        </div>
      </section>

      <section class="complyon-panel rounded-4 overflow-hidden">
        <div class="px-3 pt-3">
          <div class="complyon-section-title text-s">Approval restrictions</div>
          <div class="complyon-section-subtitle text-xs">Approvals an individual is barred from exercising - enforced as system blocks.</div>
        </div>

        <div class="table-responsive">
          <table class="table complyon-table align-middle mb-0">
            <thead>
              <tr>
                <th class="ps-3 text-xs">Ref</th>
                <th class="text-xs">Person</th>
                <th class="text-xs">Approval barred</th>
                <th class="text-xs">Scope</th>
                <th class="text-xs">Status</th>
                <th class="pe-3"></th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="row in restriction_rows"
                :key="row.id"
                class="conflicts-register-row"
                :class="{ 'is-active': active_declaration_drawer_row_key === row.id }"
                tabindex="0"
                @click="open_restriction_drawer(row)"
                @keydown.enter.prevent="open_restriction_drawer(row)"
                @keydown.space.prevent="open_restriction_drawer(row)"
              >
                <td class="ps-3 fw-semibold text-success">{{ row.ref }}</td>
                <td class="fw-semibold">{{ row.person }}</td>
                <td>{{ row.bar }}</td>
                <td>{{ row.scope }}</td>
                <td><span class="badge rounded-pill bg-danger-subtle text-danger-emphasis">{{ row.status }}</span></td>
                <td class="pe-3 text-end"><i class="bi bi-chevron-right finance-arrow"></i></td>
              </tr>
            </tbody>
          </table>
        </div>
      </section>
    </div>

    <teleport to="body">
      <div
        v-if="active_declaration_drawer && active_declaration_drawer_details"
        class="command-centre-drawer-backdrop"
        @click.self="close_declaration_drawer"
      ></div>

      <aside
        v-if="active_declaration_drawer && active_declaration_drawer_details"
        class="command-centre-drawer conflicts-register-drawer"
        role="dialog"
        aria-modal="true"
      >
        <header class="command-centre-drawer-header conflicts-register-drawer-header border-bottom">
          <div class="d-flex align-items-start justify-content-between gap-3">
            <div class="min-w-0">
              <div class="conflicts-register-drawer-kicker">
                Declaration · {{ active_declaration_drawer.ref }} · {{ String(active_declaration_drawer.type).toUpperCase() }}
              </div>
              <div class="conflicts-register-drawer-title mt-1">{{ active_declaration_drawer.person }} - {{ active_declaration_drawer.role }}</div>
              <div class="conflicts-register-drawer-subtitle mt-1">
                {{ active_declaration_drawer.department }} - declared {{ active_action_or_default(active_declaration_drawer_details.declared_date, 'On file') }}
              </div>
            </div>
            <div class="d-flex align-items-start gap-2 flex-shrink-0">
              <span class="badge rounded-pill conflicts-register-top-pill" :class="declaration_status_chip_class(active_declaration_drawer.status.label)">
                {{ active_declaration_drawer.status.label }}
              </span>
              <button type="button" class="btn btn-link p-0 command-centre-drawer-close" @click="close_declaration_drawer" aria-label="Close drawer">
                <i class="bi bi-x-lg"></i>
              </button>
            </div>
          </div>
        </header>

        <div class="command-centre-drawer-body conflicts-register-drawer-body">
          <section class="conflicts-register-drawer-summary">
            <div class="conflicts-register-drawer-summary-item">
              <div class="conflicts-register-drawer-summary-label">Type</div>
              <div class="badge rounded-pill conflicts-register-summary-pill bg-light text-secondary border border-light">{{ active_declaration_drawer.type }}</div>
            </div>
            <div class="conflicts-register-drawer-summary-item">
              <div class="conflicts-register-drawer-summary-label">Conflict rating</div>
              <div class="badge rounded-pill conflicts-register-summary-pill" :class="declaration_rating_chip_class(active_declaration_drawer.rating)">{{ active_declaration_drawer.rating }}</div>
            </div>
            <div class="conflicts-register-drawer-summary-item">
              <div class="conflicts-register-drawer-summary-label">Status</div>
              <div class="badge rounded-pill conflicts-register-summary-pill" :class="declaration_status_chip_class(active_declaration_drawer.status.label)">{{ active_declaration_drawer.status.label }}</div>
            </div>
            <div class="conflicts-register-drawer-summary-item">
              <div class="conflicts-register-drawer-summary-label">Related party</div>
              <div class="conflicts-register-summary-value">{{ active_declaration_drawer.related_party }}</div>
            </div>
          </section>

          <section class="conflicts-register-drawer-note-card">
            <div class="d-flex align-items-start gap-2">
              <div class="conflicts-register-drawer-note-icon">
                <i class="bi bi-stars"></i>
              </div>
              <div class="min-w-0">
                <div class="conflicts-register-drawer-note-label">Nature of interest</div>
                <div class="conflicts-register-drawer-note-copy">{{ active_declaration_drawer_details.nature }}</div>
              </div>
            </div>
          </section>

          <section v-if="active_declaration_drawer_details.show_workflow !== false" class="conflicts-register-drawer-section">
            <div class="conflicts-register-drawer-section-title">Declaration workflow</div>
            <div class="conflicts-register-drawer-workflow">
              <span
                v-for="step in active_declaration_workflow"
                :key="`${active_declaration_drawer.ref}-${step.label}`"
                class="conflicts-register-drawer-workflow-chip"
                :class="declaration_workflow_chip_class(step.state)"
              >
                <span class="conflicts-register-drawer-workflow-chip-icon">
                  <i class="bi" :class="declaration_workflow_icon(step.state)"></i>
                </span>
                {{ step.label }}
              </span>
            </div>
          </section>

          <section class="conflicts-register-drawer-section">
            <div class="conflicts-register-drawer-section-title">Conflict assessment</div>
            <div v-if="active_declaration_drawer_details.assessment" class="conflicts-register-drawer-assessment">
              <div class="d-flex align-items-start justify-content-between gap-2">
                <div class="d-flex align-items-start gap-2 min-w-0">
                  <div class="conflicts-register-drawer-note-icon">
                    <i class="bi bi-check2-circle"></i>
                  </div>
                  <div class="min-w-0">
                    <div class="conflicts-register-drawer-assessment-title">{{ active_declaration_drawer_details.assessment.title }}</div>
                    <div class="conflicts-register-drawer-assessment-copy">{{ active_declaration_drawer_details.assessment.copy }}</div>
                  </div>
                </div>
                <span v-if="active_declaration_drawer_details.assessment.badge" class="badge rounded-pill conflicts-register-summary-pill" :class="declaration_rating_chip_class(active_declaration_drawer_details.assessment.badge)">
                  {{ active_declaration_drawer_details.assessment.badge }} rating
                </span>
              </div>
              <div class="conflicts-register-drawer-assessment-decision mt-2">
                <div class="conflicts-register-drawer-summary-label mb-1">Decision</div>
                <div class="conflicts-register-summary-value">{{ active_declaration_drawer_details.assessment.decision }}</div>
              </div>
            </div>
            <div v-else class="conflicts-register-empty-note">
              Not yet assessed. Use Assess conflict to rate and decide.
            </div>
          </section>

          <section class="conflicts-register-drawer-section">
            <div class="conflicts-register-drawer-section-title">Connected records</div>
            <div class="conflicts-register-record-grid mt-2">
              <article v-for="record in active_declaration_drawer_details.connected_records" :key="`${active_declaration_drawer.ref}-${record.type}-${record.title}`" class="conflicts-register-record-card">
                <div class="d-flex align-items-start gap-2">
                  <div class="conflicts-register-record-icon">
                    <i class="bi" :class="declaration_record_icon(record.type)"></i>
                  </div>
                  <div class="min-w-0 flex-grow-1">
                    <div class="conflicts-register-record-type">{{ record.type }}</div>
                    <div class="conflicts-register-record-title">{{ record.title }}</div>
                  </div>
                  <i class="bi bi-box-arrow-up-right conflicts-register-record-link"></i>
                </div>
              </article>
            </div>
          </section>

          <section class="conflicts-register-drawer-section">
            <div class="d-flex align-items-center justify-content-between gap-2">
              <div class="conflicts-register-drawer-section-title">Mitigation actions</div>
              <button type="button" class="btn btn-link text-decoration-none p-0 conflicts-register-inline-link">+ Add</button>
            </div>
            <div v-if="active_declaration_drawer_details.mitigation_actions.length" class="d-grid gap-2 mt-2">
              <article v-for="item in active_declaration_drawer_details.mitigation_actions" :key="`${active_declaration_drawer.ref}-mit-${item.title}`" class="conflicts-register-action-card">
                <div class="d-flex align-items-start justify-content-between gap-2">
                  <div class="d-flex align-items-start gap-2 min-w-0">
                    <div class="conflicts-register-record-icon">
                      <i class="bi bi-check2-square"></i>
                    </div>
                    <div class="min-w-0">
                      <div class="conflicts-register-action-title">{{ item.title }}</div>
                      <div class="conflicts-register-action-meta">{{ item.meta }}</div>
                    </div>
                  </div>
                  <span class="badge rounded-pill conflicts-register-summary-pill" :class="item.status === 'Done' ? 'bg-success-subtle text-success-emphasis' : item.status === 'In progress' ? 'bg-warning-subtle text-warning-emphasis' : 'bg-light text-secondary border border-light'">{{ item.status }}</span>
                </div>
              </article>
            </div>
            <div v-else class="conflicts-register-empty-note">None recorded.</div>
          </section>

          <section class="conflicts-register-drawer-section">
            <div class="d-flex align-items-center justify-content-between gap-2">
              <div class="conflicts-register-drawer-section-title">Recusal tracking</div>
              <button type="button" class="btn btn-link text-decoration-none p-0 conflicts-register-inline-link">+ Add</button>
            </div>
            <div v-if="active_declaration_drawer_details.recusals.length" class="d-grid gap-2 mt-2">
              <article
                v-for="item in active_declaration_drawer_details.recusals"
                :key="`${active_declaration_drawer.ref}-rec-${item.title}`"
                class="conflicts-register-action-card"
                :class="{ 'is-focused': active_declaration_drawer_details.selected_recusal === item.title }"
              >
                <div class="d-flex align-items-start justify-content-between gap-2">
                  <div class="d-flex align-items-start gap-2 min-w-0">
                    <div class="conflicts-register-record-icon">
                      <i class="bi bi-shield-x"></i>
                    </div>
                    <div class="min-w-0">
                      <div class="conflicts-register-action-title">{{ item.title }}</div>
                      <div class="conflicts-register-action-meta">{{ item.meta }}</div>
                    </div>
                  </div>
                  <span class="badge rounded-pill conflicts-register-summary-pill" :class="item.status === 'Active' ? 'bg-warning-subtle text-warning-emphasis' : 'bg-light text-secondary border border-light'">{{ item.status }}</span>
                </div>
              </article>
            </div>
            <div v-else class="conflicts-register-empty-note">None recorded.</div>
          </section>

          <section class="conflicts-register-drawer-section">
            <div class="d-flex align-items-center justify-content-between gap-2">
              <div class="conflicts-register-drawer-section-title">Approval restrictions</div>
              <button type="button" class="btn btn-link text-decoration-none p-0 conflicts-register-inline-link">+ Add</button>
            </div>
            <div v-if="active_declaration_drawer_details.restrictions.length" class="d-grid gap-2 mt-2">
              <article
                v-for="item in active_declaration_drawer_details.restrictions"
                :key="`${active_declaration_drawer.ref}-rest-${item.title}`"
                class="conflicts-register-action-card"
                :class="{ 'is-focused': active_declaration_drawer_details.selected_restriction === item.title }"
              >
                <div class="d-flex align-items-start justify-content-between gap-2">
                  <div class="d-flex align-items-start gap-2 min-w-0">
                    <div class="conflicts-register-record-icon">
                      <i class="bi bi-slash-circle"></i>
                    </div>
                    <div class="min-w-0">
                      <div class="conflicts-register-action-title">{{ item.title }}</div>
                      <div class="conflicts-register-action-meta">{{ item.meta }}</div>
                    </div>
                  </div>
                  <span class="badge rounded-pill conflicts-register-summary-pill bg-danger-subtle text-danger-emphasis">{{ item.status }}</span>
                </div>
              </article>
            </div>
            <div v-else class="conflicts-register-empty-note">None recorded.</div>
          </section>

          <section class="conflicts-register-drawer-section">
            <div class="conflicts-register-drawer-section-title">Conflict evidence trail</div>
            <div v-if="active_declaration_drawer_details.evidence.length" class="d-flex flex-wrap gap-2 mt-2">
              <span v-for="item in active_declaration_drawer_details.evidence" :key="`${active_declaration_drawer.ref}-evidence-${item.label}`" class="conflicts-register-evidence-chip">
                {{ item.label }}
                <span class="badge rounded-pill conflicts-register-evidence-tag">{{ item.tag }}</span>
              </span>
            </div>
            <div v-else class="conflicts-register-empty-note">No evidence attached.</div>
          </section>

          <section class="conflicts-register-drawer-section">
            <div class="conflicts-register-drawer-section-title">Declaration audit trail</div>
            <div class="conflicts-register-timeline mt-2">
              <div v-for="item in active_declaration_drawer_details.activity" :key="`${active_declaration_drawer.ref}-${item.title}-${item.date}`" class="conflicts-register-timeline-item">
                <div class="d-flex align-items-center justify-content-between gap-2">
                  <div class="conflicts-register-action-title">{{ item.title }}</div>
                  <div class="conflicts-register-action-meta">{{ item.date }}</div>
                </div>
                <div class="conflicts-register-action-meta">{{ item.actor }}</div>
              </div>
            </div>
          </section>
        </div>

        <footer class="command-centre-drawer-footer conflicts-register-drawer-footer border-top">
          <div class="d-flex align-items-center justify-content-between gap-2">
            <button type="button" class="btn btn-link text-decoration-none conflicts-register-footer-link">
              <i class="bi bi-stars me-1"></i>
              Assess conflict
            </button>
            <button type="button" class="btn config-navbar-primary-action conflicts-register-footer-primary">
              <i class="bi bi-pencil-square me-1"></i>
              Edit
            </button>
          </div>
        </footer>
      </aside>
    </teleport>

    <teleport to="body">
      <div
        v-if="show_new_declaration_modal"
        class="conflicts-modal-backdrop"
        @click="close_new_declaration_modal"
      ></div>

      <section
        v-if="show_new_declaration_modal"
        class="conflicts-modal"
        role="dialog"
        aria-modal="true"
        aria-label="New declaration"
      >
        <div class="conflicts-modal-panel">
          <div class="conflicts-modal-header">
            <div class="d-flex align-items-start justify-content-between gap-3">
              <div class="min-w-0">
                <h2 class="conflicts-modal-title mb-2">New declaration</h2>
                <p class="conflicts-modal-subtitle mb-0">
                  Assessment, mitigation, recusals and restrictions are managed inside the declaration.
                </p>
              </div>
              <button
                type="button"
                class="btn btn-link text-decoration-none p-0 conflicts-modal-close"
                @click="close_new_declaration_modal"
                aria-label="Close modal"
              >
                <i class="bi bi-x-lg fs-6"></i>
              </button>
            </div>
          </div>

          <form class="conflicts-modal-body" @submit.prevent="create_new_declaration">
            <div class="row g-3">
              <div class="col-12 col-md-6">
                <label class="conflicts-modal-field-label text-xs">Person</label>
                <input
                  v-model="new_declaration_form.person"
                  type="text"
                  class="form-control conflicts-modal-input"
                  placeholder="Name"
                />
              </div>

              <div class="col-12 col-md-6">
                <label class="conflicts-modal-field-label text-xs">Role</label>
                <input
                  v-model="new_declaration_form.role"
                  type="text"
                  class="form-control conflicts-modal-input"
                  placeholder="Job title"
                />
              </div>

              <div class="col-12 col-md-6">
                <label class="conflicts-modal-field-label text-xs">Department</label>
                <input
                  v-model="new_declaration_form.department"
                  type="text"
                  class="form-control conflicts-modal-input"
                  placeholder="Procurement"
                />
              </div>

              <div class="col-12 col-md-6">
                <label class="conflicts-modal-field-label text-xs">Declaration type</label>
                <select v-model="new_declaration_form.type" class="form-select conflicts-modal-input">
                  <option v-for="type in declaration_type_options" :key="type" :value="type">{{ type }}</option>
                </select>
              </div>

              <div class="col-12">
                <label class="conflicts-modal-field-label text-xs">Nature of interest</label>
                <textarea
                  v-model="new_declaration_form.nature"
                  rows="2"
                  class="form-control conflicts-modal-input conflicts-modal-textarea"
                  placeholder="What is being declared"
                ></textarea>
              </div>

              <div class="col-12 col-md-6">
                <label class="conflicts-modal-field-label text-xs">Related party</label>
                <input
                  v-model="new_declaration_form.related_party"
                  type="text"
                  class="form-control conflicts-modal-input"
                  placeholder="Supplier / entity / —"
                />
              </div>

              <div class="col-12 col-md-6">
                <label class="conflicts-modal-field-label text-xs">Declared date</label>
                <input
                  v-model="new_declaration_form.declared_date"
                  type="text"
                  class="form-control conflicts-modal-input"
                  placeholder="e.g. 12 Mar 2026"
                />
              </div>

              <div class="col-12 col-md-6">
                <label class="conflicts-modal-field-label text-xs">Conflict rating</label>
                <select v-model="new_declaration_form.rating" class="form-select conflicts-modal-input">
                  <option v-for="rating in declaration_rating_options" :key="rating" :value="rating">{{ rating }}</option>
                </select>
              </div>

              <div class="col-12 col-md-6">
                <label class="conflicts-modal-field-label text-xs">Status</label>
                <select v-model="new_declaration_form.status" class="form-select conflicts-modal-input">
                  <option v-for="status in declaration_status_options" :key="status" :value="status">{{ status }}</option>
                </select>
              </div>
            </div>

            <div v-if="new_declaration_error" class="conflicts-modal-error mt-3">
              {{ new_declaration_error }}
            </div>
          </form>

          <div class="conflicts-modal-footer">
            <button type="button" class="btn conflicts-modal-cancel" @click="close_new_declaration_modal">Cancel</button>
            <button type="button" class="btn conflicts-modal-submit d-inline-flex align-items-center gap-2" @click="create_new_declaration">
              <i class="bi bi-plus-lg"></i>
              <span>Create</span>
            </button>
          </div>
        </div>
      </section>
    </teleport>
  </div>
</div>
